import $ from 'jquery'
import 'jquery-match-height'

$(document).ready(function ($) {
	$('#back-button').on('click', function (e) {
		e.preventDefault()
		if (
			document.referrer &&
			window.location.hostname === document.referrer.split('/')[2] &&
			window.history.length > 1
		) {
			window.history.back()
		} else {
			window.location.href = '/'
		}
	})

	//Match Height
	$('.match-height-1').matchHeight()
	$('.match-height-2').matchHeight()
	//Link card
	$('.link-card-items').each(function () {
		const count = $(this).children().length
		$(this).slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: true,
			autoplay: true,
			centerMode: count < 4 ? true : false,
			autoplaySpeed: 6000,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						centerMode: count < 3 ? true : false
					}
				},
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: false
					}
				}
			]
		})
	})

	//Story in continent page
	$('.story-items-slider').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		arrows: true,
		autoplay: true,

		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	})
})
